/**
 * Standard responsive image sizes for Next.js Image `sizes` prop
 * Based on actual component usage patterns in the codebase
 *
 * These values tell the browser what size the image will be at different breakpoints,
 * allowing Next.js to generate an optimized srcset with appropriate image widths.
 *
 * Format: "(media-query) size, default-size"
 * Example: "(max-width: 600px) 163px, 212px" means:
 *   - On screens 600px or narrower, image will be 163px wide
 *   - On larger screens, image will be 212px wide
 */
export const IMAGE_SIZES = {
  // Full-width images
  FULL_WIDTH: '100vw',

  // Product card images (most common)
  // Mobile: 144px, Desktop: 163px
  PRODUCT_CARD: '(max-width: 600px) 144px, 163px',

  // Sidebar Product card images
  // Mobile: 100px, Desktop: 294px
  // Breakpoint matches the theme's `md` (1080px), where SidebarProductCard
  // actually switches between Mobile and Desktop, not the 600px used elsewhere
  SIDEBAR_PRODUCT_CARD: '(max-width: 1079px) 100px, 294px',

  // Mini product cards
  MINI_PRODUCT_CARD: '(max-width: 600px) 120px, 150px',

  // Hero/Featured images on landing pages
  // Mobile: ~310px, Tablet: ~338px, Desktop: ~415px
  HERO_CARD: '(max-width: 600px) 310px, (max-width: 900px) 338px, 415px',

  // Author avatars
  AVATAR: '(max-width: 600px) 80px, 120px',

  // Content images (variable width based on content area)
  CONTENT_IMAGE: '(max-width: 600px) 100vw, (max-width: 900px) 80vw, 720px',

  // Expert opinion images
  EXPERT_IMAGE: '(max-width: 600px) 275px, 194px',

  // Summary table card images
  SUMMARY_TABLE_CARD: '106px',
} as const;
